import _ from 'lodash';
import {
  APL_SAMPLE_REQUEST_DYNAMIC_CONTENT,
  SHIPPING_ADDRESS,
} from '../../modal/product-apl/Constants';
import { MASTER_APL_NAME } from './constants';

export const groupRequestSample = (productList) => {
  if (productList?.length === 0) return null;

  let _productRequest = {};
  productList?.forEach((product) => {
    const contactEmail = product?.contactEmail?.toLowerCase();

    const sampleData = {
      isValid: false,
      isValidEmail: true,
      dynamicContent: APL_SAMPLE_REQUEST_DYNAMIC_CONTENT,
    };

    if (contactEmail) {
      _productRequest[contactEmail] = {
        ...sampleData,
        productList: [
          ...(_productRequest?.[contactEmail]?.productList ?? []),
          product,
        ],
      };
    } else {
      _productRequest['Empty'] = {
        ...sampleData,
        productList: [
          ...(_productRequest?.['Empty']?.productList ?? []),
          product,
        ],
        isValidEmail: false,
      };
    }
  });
  return _productRequest;
};

export const updateDynamicContent = ({
  requestSampleData,
  allValues,
  fieldChange,
  contactEmail,
  addressSync,
}) => {
  const { dynamicContent } = requestSampleData[contactEmail];

  const requiredFields = Object.keys(dynamicContent)?.filter(
    (field) =>
      dynamicContent[field]?.required &&
      dynamicContent[field]?.show &&
      dynamicContent[field]?.visible
  );

  const isValid = requiredFields?.every((field) => allValues[field]);
  const field = Object.keys(fieldChange)[0];
  const value = fieldChange[field];
  const isShipping = SHIPPING_ADDRESS?.includes(field);

  const _addressSync = _.cloneDeep(requestSampleData);

  const isShippingInfoSync = isShipping && addressSync;

  if (isShippingInfoSync) {
    Object.keys(requestSampleData)?.forEach((contactEmail) => {
      _addressSync[contactEmail].dynamicContent[field].value = value;
    });
  } else {
    _addressSync[contactEmail].dynamicContent[field].value = value;
  }

  _addressSync[contactEmail].isValid = isValid;

  return _addressSync;
};
